import { mappers } from './utils';
import { ICheckServiceParams, TCheckServiceResult } from './types';
import { fetchCheckService } from '../../repositories/billing-tariffs/v3/check-service';
import { THeaders } from '../../types/request';
import { ECheckServiceErrorCode } from '../../types/reducers/checkoutInfo';

export async function checkService(params: ICheckServiceParams): Promise<TCheckServiceResult> {
  const { httpApi, logger, telemetry, parameters } = params;

  const requestConfig = {
    headers: [['Content-Type', 'application/json']] as THeaders,
  };

  try {
    const response = await fetchCheckService({
      httpApi,
      parameters,
      config: { requestConfig },
      mappers,
    });

    telemetry.increment('check-service-request.success');

    return response as TCheckServiceResult;
  } catch (error) {
    logger.error(error, {
      description: 'Запрос /check-service на ФП',
      degradation: 'Пользователь не сможет разместить объявление',
    });

    telemetry.increment('check-service-request.fail');

    return {
      success: false,
      payload: ECheckServiceErrorCode.fatalError,
    };
  }
}
